// LIBRERIE/IMPORTS
import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import he from 'he';

//HOOKS
import { useGetAgencyDetails } from "../../hooks/useGetAgencyDetails";


// COMPONENTI
import SubHeaderDefault from "../Header/subHeader/SubHeaderDefault";

interface ServicesProps {
    agencyId: number;
}

const Services: React.FC<ServicesProps> = ({agencyId}) => {

    const { t } = useTranslation();

    const { agency } = useGetAgencyDetails(agencyId);

    return (
        <>
            <Helmet>
                <title>{t('servicesPage.pageTitle')} | {he.decode(`${agency?.agencyName}`) || 'Agenzia Immobiliare'}</title>
            </Helmet>

            <SubHeaderDefault title={t('servicesPage.pageTitle')} isSeo={true} />

            <main id="services-page" className="space-ptb">
                <div className="container-fluid w-90">
                    <p dangerouslySetInnerHTML={{ __html: t('servicesPage.para1') as string }}></p>
                    <p dangerouslySetInnerHTML={{ __html: t('servicesPage.para2') as string }}></p>
                    <p dangerouslySetInnerHTML={{ __html: t('servicesPage.para3') as string }}></p>
                    <p dangerouslySetInnerHTML={{ __html: t('servicesPage.para4') as string }}></p>
                    <p className="slogan p-3 p-xl-4" dangerouslySetInnerHTML={{ __html: t('servicesPage.slogan') as string }}></p>
                </div>
            </main>
        </>
    );
};

export default Services;